import gql from "graphql-tag";

export const getLicenses = gql`
	query getLicenses {
		licenses @client {
			subscriptions {
				id
				dbID
				productTitle
				licenseName
				serialNumbers
				type
				expirationDate
				purchaseDate
				status
				isExpired
				isAutoBillingEnabled
				isActive
				isTrial
				lastOrder {
					orderNumber
					isSerialNumberGenerationPending
				}
			}
			perpetuals {
				id
				dbID
				productTitle
				licenseName
				serialNumbers
				type
				expirationDate
				purchaseDate
				status
				isExpired
			}
		}
	}
`;

export const readLicenses = (data = {}) => data.licenses || { subscriptions: [], perpetuals: [] };

export const getLicense = gql`
	query getLicense($id: ID!) {
		license(id: $id) @client {
			id
			dbID
			productTitle
			licenseName
			serialNumbers
			type
			expirationDate
			purchaseDate
			isExpired
			status
			isAutoBillingEnabled
			isActive
			isTrial
			lastOrder {
				orderNumber
				isSerialNumberGenerationPending
			}
		}
	}
`;

export const readLicense = (data = {}) => data.license || null;
